import React, { useEffect, useState } from 'react'
import { Button, Grid } from '@mui/material'
import { Box } from '@mui/system'
import CustomDatePicker from '../../../../common/CustomDatePicker'
import MultiSelectDropDown from '../../../../form-components/MultiSelectDropDownComponent'
import ReportHeader from '../../../../common/ReportHeader'
import { focusElemnt, formatDate, navigation1, navigation3 } from '../../../../../utilityFunctions'
import moment from 'moment'
import jsPDF from 'jspdf'
import { callAddFontRobotoNormal } from '../../../../../assets/fonts/Roboto-normal'
import { callAddFontRobotoBold } from '../../../../../assets/fonts/Roboto-bold'
import autoTable from 'jspdf-autotable'
import { jsPdfDidParseCellCallback, jsPdfWillDrawCellCallback } from '../../../../generics/helper'
import excelExport from '../../../../../assets/extra/export-excel'
import { excelConfig } from '../../../../../assets/extra/excelConfig'
import { useDispatch, useSelector } from "react-redux";
import { getUserList } from '../../../../../redux/KSRTC_Redux/userConfig/UserAction'
import { divisionFilterList, getDepotList } from '../../../../../redux/KSRTC_Redux/MasterConfig/MasterAction'
import { getPassDetailReport } from '../../../../../redux/KSRTC_Redux/ReportsPage/ReportsAction'
import Alert from '../../../../common/Alert'
import { columnDefsMonthlyPassReport } from '../../reportConstants'
import { otherReportMenu, reportMenu } from '../../../../../redux/Actions'
import MonthlyPassDetailReportTable from './MonthlyPassDetailReportTable'

const MonthlyPassDetailReport = () => {
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { user, masterConfig } = store
    const [filterVal, setFilterVal] = useState({
        fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
        toDate: formatDate(window.getTime ? window.getTime() : new Date()),
        division: [],
        divisionList: [],
        reportTableData: [],
        showReport: false,
        isPdfLoaded: false,
        header: {}
    })
    // for alert
    const [showAlert, setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [alertType, setAlertType] = useState("error");
    const LoginId = sessionStorage.getItem('LoginId')
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    const handleSetAlert = (type, msg) => {
        if (type === "success") setAlertType("success");
        else setAlertType("error");
        setAlertMsg(msg);
        setShowAlert(true);
    };
    const handleAlertClose = () => {
        setShowAlert(false);
    };
    const handleResetValue = () => {
        let divisionOpt = masterConfig?.divisionList?.map((val) => ({ ...val, DivisionCodeName: `${val?.DivisionName}(${val?.DivisionCode})` }))
        setFilterVal((prev) => ({
            ...prev,
            fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
            toDate: formatDate(window.getTime ? window.getTime() : new Date()),
            division: divisionOpt,
            divisionList: divisionOpt,
            reportTableData: [],
            showReport: false,
            isPdfLoaded: false,
        }))
    }
    useEffect(() => {
        const divisionBody = {
            DivisionID: 0,
            CorporationID: 0,
            ClientID: user?.CompanyID === 1 ? 1 : 2
        }
        dispatch(divisionFilterList(divisionBody, true, 60 * 60 * 1000))
        const depotBody = {
            CompanyID: 0,
            DivisionID: 0,
            CorporationID: 0,
            CityID: 0,
            ClientID: user?.CompanyID === 1 ? 1 : 2
        }
        dispatch(getDepotList(depotBody, true, 60 * 60 * 1000))
        const userBody = {
            CompanyID: user?.CompanyID,
            UserID: 0,
            BranchID: 0,
        }
        dispatch(getUserList(userBody, true, 60 * 60 * 1000))
    }, [])
    useEffect(() => {
        if (masterConfig?.divisionList?.length > 0) {
            let divisionOpt = masterConfig?.divisionList?.map((val) => ({ ...val, DivisionCodeName: `${val?.DivisionName}(${val?.DivisionCode})` }))
            setFilterVal((prev) => ({
                ...prev,
                divisionList: divisionOpt,
                division: divisionOpt
            }))
        }
    }, [masterConfig?.divisionList])

    const divisionProps = () => {
        return {
            id: 'division',
            width: "100%",
            name: "division",
            label: "",
            isCompulsory: false,
            options: filterVal?.divisionList || [],
            preSelectedValues: filterVal?.division,
            searchPlaceholder: "Search by Division",
            isObject: true,
            primaryKey: 'DivisionID',
            labelKey: 'DivisionCodeName',
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            searchByCode: true,
            searchByName: "DivisionName",
            prevId: "depot",
            nextId: "fromCancelDate",
        }
    }
    useEffect(() => {
        focusElemnt("userName");
    }, [])
    const reportExcelExport = async (reportData, extension) => {
        try {
            setFilterVal((prev) => ({ ...prev, isPdfLoaded: true }))
            const xlColumns = columnDefsMonthlyPassReport.map((col) => {
                return { colHeader: col.exportHead, field: col.field, xlCol: col.xlCol }
            });
            const xlConfig = {
                ...excelConfig,
                columns: xlColumns,
                fileName: `MONTHLY_PASS_DETAIL_REPORT.${extension}`,
                showFilterSection: true,
                showSummarySection: true,
                showEmptyRow: true,
                headerRowStyle: { fill: '', bold: true },
                borderStyle: {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                },
                showHeader: true,
                workSheetTitle: `MONTHLY_PASS_DETAIL_REPORT`,
                headerFooter: {
                    firstHeader: "MONTHLY_PASS_DETAIL_REPORT",
                    firstFooter: "MONTHLY_PASS_DETAIL_REPORT"
                },
                sheetHeaderData: [
                    {
                        "caption": "KARNATAKA STATE ROAD TRANSPORT CORPORATION",
                        "colSpan": 5,
                        "horizontal": "center",
                        "newRow": true
                    },
                    {
                        "caption": "Monthly Pass Detail Report",
                        "colSpan": 5,
                        "size": 12,
                        "horizontal": "center",
                        "newRow": true
                    },
                    {
                        "caption": "Divison: ",
                        "value": `${filterVal?.division?.length > 0 ? filterVal?.division?.length === 1 ? filterVal?.division[0]?.DivisionName : "All" : "All"}`,
                        "colSpan": 3,
                        "size": 10,
                    },
                    {
                        "caption": `User:${user?.UserName} (${LoginId})`,
                        "value": "",
                        "colSpan": 2,
                        "horizontal": "right",
                        "size": 10,
                        "newRow": true
                    },

                    {
                        "caption": "From Date:",
                        "value": `${moment(filterVal?.fromDate).format("DD-MMM-YYYY")}`,
                        "colSpan": 3,
                        "size": 10
                    },
                    {
                        "caption": "Print Date & Time:",
                        "value": `${currentDateTime}`,
                        "colSpan": 2,
                        "horizontal": "right",
                        "size": 10,
                        "newRow": true
                    },
                    {
                        "caption": "To Date:",
                        "value": `${moment(filterVal?.toDate).format("DD-MMM-YYYY")}`,
                        "colSpan": 5,
                        "size": 10,
                    },

                ],
            };
            await excelExport.processExcel(xlConfig, reportData)
            setFilterVal((prev) => ({ ...prev, isPdfLoaded: false }))
        } catch (err) {
            console.log(err);
            setFilterVal((prev) => ({ ...prev, isPdfLoaded: false }))
        }
    }

    // for Export as Pdf and Print
    const printReport = (tableData) => {
        try {
            setFilterVal((prev) => ({ ...prev, isPdfLoaded: false }))
            const cancellationColumns = columnDefsMonthlyPassReport.map((col) => {
                return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
            });

            jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
            jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);

            const doc = new jsPDF({
                orientation: 'l',
                format: 'a4',
            });

            var totalPagesExp = '{total_pages_count_string}';
            doc.autoTableSetDefaults({
                headStyles: { fontSize: 8, halign: 'left', fillColor: [30, 89, 167], },
            });

            const startY = 10;

            // Add the text at the top of the page
            doc.setFontSize(14);
            doc.setTextColor("#000000");
            doc.setFont('Roboto', 'bold');
            doc.text(`KARNATAKA STATE ROAD TRANSPORT CORPORATION`, 90, startY);

            doc.setFont('Roboto', 'normal');
            doc.setFontSize(10);
            doc.setTextColor("#000000");
            doc.text(`MONTHLY PASS DETAIL REPORT`, 115, startY + 8);

            doc.setFontSize(10);
            doc.setTextColor("#000000");
            doc.text(`Division: ${filterVal?.division?.length > 1 ? 'All' : filterVal?.division[0]?.DivisionCode}`, 5, startY + 14);
            doc.text(`User : ${user?.UserName} (${LoginId})`, doc.internal.pageSize.width - 5, startY + 14, 'right');
            doc.text(`Print Date & Time : ${currentDateTime}`, doc.internal.pageSize.width - 5, startY + 20, 'right');
            doc.text(`From : ${moment(filterVal?.fromDate).format('DD-MMM-YYYY')}`, 5, startY + 20);
            doc.text(`To : ${moment(filterVal?.toDate).format('DD-MMM-YYYY')}`, 5, startY + 26);

            // Print the table on the first page
            autoTable(doc, {
                startY: startY + 30,
                margin: { top: 3, left: 5, right: 5, bottom: 3 },
                tableWidth: 'auto',
                columns: cancellationColumns,
                body: tableData,
                columnStyles:
                {
                    0: { halign: 'left', fontSize: 8 },
                    1: { halign: 'left', fontSize: 8 },
                    2: { halign: 'left', fontSize: 8 },
                    3: { halign: 'left', fontSize: 8 },
                    4: { halign: 'left', fontSize: 8 },
                    5: { halign: 'left', fontSize: 8 },
                    6: { halign: 'left', fontSize: 8 },
                    7: { halign: 'left', fontSize: 8 },
                    8: { halign: 'left', fontSize: 8 },
                    9: { halign: 'left', fontSize: 8 },
                    10: { halign: 'left', fontSize: 8 },
                    11: { halign: 'left', fontSize: 8 },
                    12: { halign: 'right', fontSize: 8 },
                    13: { halign: 'right', fontSize: 8 },
                    14: { halign: 'right', fontSize: 8 },
                    15: { halign: 'right', fontSize: 8 },
                },
                theme: 'grid',
                headStyles: {
                    fillColor: null,
                    textColor: [0, 0, 0],
                    lineWidth: 0.2,
                },
                didParseCell: (data) => {
                    jsPdfDidParseCellCallback(data, cancellationColumns, []);
                },
                willDrawCell: (data) => {
                    jsPdfWillDrawCellCallback(data, true);
                },
                didDrawPage: function (data) {
                    data.settings.margin.top = 10;
                },
                pageBreak: "auto"
            });
            // Add total pages if available
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp)
            }
            setFilterVal((prev) => ({ ...prev, isPdfLoaded: false }))
            // Trigger download
            const pdfData = doc.output('blob');
            const pdfUrl = URL.createObjectURL(pdfData);
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = 'MonthlyPassDetailReport.pdf';
            link.click();
        }
        catch (error) {
            console.log("Error: ", error);
            setFilterVal((prev) => ({ ...prev, isPdfLoaded: false }))
        }
    }


    const handleSubmit = (id = 0, extension = 'xlsx') => {
        if ((moment(filterVal?.toDate).startOf().diff(moment(filterVal?.fromDate).endOf(), 'days')) > 30) {
            handleSetAlert('error', "This report cannot be taken for more than 31 days")
            return
        }
        setFilterVal((prev) => ({ ...prev, reportTableData: [] }))
        const body = {
            intDivisionID: filterVal?.division?.length > 1 ? 0 : filterVal?.division[0]?.DivisionID,
            FromDate: moment(filterVal?.fromDate).format('YYYY-MM-DD'),
            ToDate: moment(filterVal?.toDate).format('YYYY-MM-DD')
        }
        dispatch(getPassDetailReport(body)).then((res) => {
            if (res.status === 200 && res.data.status) {
                let data = res.data?.Data?.Table
                if (data?.length > 0) {
                    let newData = data.map((obj, index) => {
                        return {
                            ...obj,
                            isDataRow: true,
                            sNo: index + 1,
                            FromDate: obj.FromDate?.split(' ')[0],
                            IssuedOn: obj.IssuedOn?.split(' ')[0],
                            ToDate: obj.ToDate?.split(' ')[0]
                        };
                    });
                    const totalRow = newData.reduce(
                        (acc, curr) => {
                            acc.GST += Number(curr.GST || 0);
                            acc.PassAmount += Number(curr.PassAmount || 0);
                            acc.TotalFare += Number(curr.TotalFare || 0);
                            acc.NoOfTimesTravelled += Number(curr.NoOfTimesTravelled || 0);
                            return acc;
                        },
                        {
                            totalCaption: "Total",
                            GST: 0,
                            PassAmount: 0,
                            TotalFare: 0,
                            NoOfTimesTravelled: 0,
                            isTotalRow: true
                        }
                    );
                    newData.push(totalRow);
                    if (id === 1) {
                        printReport(newData.length >= 1 ? newData : [])
                    } else if (id === 2) {
                        reportExcelExport(newData.length >= 1 ? newData : [], extension)
                    } else {
                        setFilterVal((prev) => ({
                            ...prev, showReport: true, reportTableData: newData,
                            header: { fromDate: moment(filterVal?.fromDate).format('DD-MMM-YYYY'), toDate: moment(filterVal?.toDate).format('DD-MMM-YYYY'), division: filterVal?.division?.length > 1 ? 'All' : filterVal?.division[0]?.DivisionCodeName }
                        }))
                        setTimeout(() => {
                            focusElemnt('BackBtn')
                        }, 100)
                    }
                } else {
                    handleSetAlert('error', "No Data Found")
                }
            } else {
                handleSetAlert('error', res?.data?.Message);
            }
        })
    }
    return (
        <>
            <Box>
                {!filterVal?.showReport ? <>
                    <ReportHeader mainHeaderName='Report' headerName='Other Report' openSubMenu={() => dispatch(reportMenu(true))} subHeader={'MONTHLY PASS DETAIL REPORT'} subHeaderVisible={() => dispatch(otherReportMenu(true))} />
                    <Grid
                        container
                        spacing={0}
                        className="column-container"
                        style={{
                            padding: "16px 16px 58px 16px",
                        }}
                    >
                        <Grid item md={6.5}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px'
                            }}
                        >
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}
                            >
                                <Grid item md={4} style={{ fontWeight: '600' }}>Division</Grid>
                                <Grid item md={8}>
                                    <MultiSelectDropDown
                                        {...divisionProps()}
                                        onSelect={(val) => {
                                            setFilterVal((prev) => ({ ...prev, division: val }))
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}
                            >
                                <Grid item md={4} style={{ fontWeight: '600' }}>From Date</Grid>
                                <Grid item md={8}>
                                    <CustomDatePicker id={`fromCancelDate`} label={''} selectedDate={filterVal?.fromDate} minDate={'2024-06-19'}
                                        onChange={(value) => {
                                            if ((new Date(value) < new Date(filterVal?.toDate))) {
                                                setFilterVal((prev) => ({ ...prev, fromDate: formatDate(value) }))
                                            } else {
                                                setFilterVal((prev) => ({ ...prev, fromDate: formatDate(value), toDate: formatDate(value) }))
                                            }
                                        }}
                                        onKeyDown={(e) => { navigation1(e, 'toCancelDate', 'division') }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}
                            >
                                <Grid item md={4} style={{ fontWeight: '600' }}>To Date</Grid>
                                <Grid item md={8}>
                                    <CustomDatePicker label={''} id={`toCancelDate`} selectedDate={filterVal?.toDate}
                                        onChange={(value) => {
                                            setFilterVal((prev) => ({ ...prev, toDate: formatDate(value) }))
                                        }}
                                        onKeyDown={(e) => { navigation1(e, 'submitButton', 'fromCancelDate') }}
                                        minDate={filterVal?.fromDate}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    gap: '10px',
                                    flexWrap: 'nowrap'
                                }}
                            >
                                <Grid item md={4}></Grid>
                                <Grid item md={2}>
                                    <Button variant="contained" size="medium" id="submitButton"
                                        className={`btn-orange`}
                                        onClick={handleSubmit}
                                        onKeyDown={(e) => navigation3(e, "pdfButton", "toCancelDate", () => { handleSubmit() })}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium" id="pdfButton"
                                        className="btn-orange-outline"
                                        onClick={() => { handleSubmit(1) }}
                                        onKeyDown={(e) => navigation3(e, "excelButton", "submitButton", () => { printReport() })}
                                    >
                                        PDF
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium" id="excelButton"
                                        className="btn-orange-outline"
                                        onClick={() => { handleSubmit(2, 'xlsx') }}
                                        onKeyDown={(e) => navigation3(e, "restButton", "pdfButton", () => { reportExcelExport('xlsx') })}
                                    >
                                        EXCEL
                                    </Button>
                                </Grid>
                                {/* <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        className="btn-orange-outline"
                                        onClick={() => { handleSubmit(2, 'csv') }}
                                        id='CsvBtn'
                                        onKeyDown={(e) => navigation3(e, "ResetBtn", "ExcelBtn", () => { reportExcelExport('csv') })}
                                    >
                                        CSV
                                    </Button>
                                </Grid> */}
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium" id="restButton"
                                        className="btn-orange-outline"
                                        onClick={() => handleResetValue()}
                                        onKeyDown={(e) => navigation3(e, "", "excelButton", () => { handleResetValue() })}
                                    >
                                        RESET
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
                    :
                    <MonthlyPassDetailReportTable reportTableData={filterVal?.reportTableData} header={filterVal?.header} handleBack={() => { setFilterVal((prev) => ({ ...prev, showReport: false, reportTableData: [] })) }} />
                }

                {filterVal?.isPdfLoaded &&
                    <>
                        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '16px 16px 16px 0px', justifyContent: 'flex-end', alignItems: 'flex-end', gap: '10px', height: '76px' }}>
                            <div style={{ position: 'relative' }}>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    className={`btn-orange-outline`}
                                    onClick={() => setFilterVal((prev) => ({ ...prev, isPdfLoaded: false }))}
                                >
                                    Back
                                </Button>
                            </div>
                        </Box>
                        <object id="output" type="application/pdf" width="100%" height="350" title="MTLPL - BusCRS - Agent Voucher Report" aria-label="MTLPL - BusCRS - Agent Voucher Report"></object>
                    </>}
            </Box>
            {showAlert && (
                <Alert msg={alertMsg} alertType={alertType} close={handleAlertClose} buttonText="Ok" />
            )}
        </>
    )
}

export default MonthlyPassDetailReport;